import { useEffect } from 'react';

// Cards that get a soft accent glow following the pointer (see index.css).
const SELECTOR = [
    '.project__card',
    '.skills__group',
    '.glance__cell',
    '.about__card',
    '.security__principles li',
    '.arch__detail',
    '.contacts__details',
].join(',');

// One delegated listener writes the pointer position (--mx / --my) onto the
// card under the mouse; CSS draws the glow. Only for real mice, never touch,
// and not for reduced-motion visitors. Uses CSSOM, so it is CSP-safe.
function Spotlight() {
    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return undefined;
        const enabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches
            && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!enabled) return undefined;

        let frame = 0;
        const onMove = (event) => {
            if (event.pointerType && event.pointerType !== 'mouse') return;
            const card = event.target.closest && event.target.closest(SELECTOR);
            if (!card) return;
            const { clientX, clientY } = event;
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                const rect = card.getBoundingClientRect();
                card.style.setProperty('--mx', `${clientX - rect.left}px`);
                card.style.setProperty('--my', `${clientY - rect.top}px`);
            });
        };
        document.addEventListener('pointermove', onMove, { passive: true });
        return () => {
            document.removeEventListener('pointermove', onMove);
            cancelAnimationFrame(frame);
        };
    }, []);

    return null;
}

export default Spotlight;
